module.exports = __webpack_public_path__ + "static/media/rede-protecao-3.00393923.jpeg";